(function () {
  'use strict';

  if (!window.__defensiveBootInstalled) {
    window.__defensiveBootInstalled = true;
    // Early resource hints to improve LCP (best-effort, safe to duplicate)
    try {
      // Defensive globals baseline to prevent null refs
      if (typeof window.userData === 'undefined' || window.userData === null) {
        window.userData = {};
      }
      if (typeof window.currentUser === 'undefined') {
        window.currentUser = null;
      }
      if (typeof window.userFullyLoaded === 'undefined') {
        window.userFullyLoaded = false;
      }
      if (typeof window.getUserData !== 'function') {
        window.getUserData = function () {
          return window.userData || null;
        };
      }
      function injectLink(rel, href, attrs) {
        if (!href) return;
        const key = rel + '::' + href;
        if (
          document.head &&
          !document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)
        ) {
          const l = document.createElement('link');
          l.rel = rel;
          l.href = href;
          if (attrs) {
            Object.keys(attrs).forEach((k) => l.setAttribute(k, attrs[k]));
          }
          document.head.appendChild(l);
        }
      }
      injectLink('preconnect', 'https://netwrckstatic.netwrck.com');
      injectLink('dns-prefetch', 'https://netwrckstatic.netwrck.com');
      const skipGoogleFonts =
        window.location &&
        window.location.pathname.replace(/\/+$/, '') === '/tools/video-editor';
      if (!skipGoogleFonts) {
        injectLink('preconnect', 'https://fonts.googleapis.com');
        injectLink('preconnect', 'https://fonts.gstatic.com', {
          crossorigin: 'anonymous',
        });
        injectLink('dns-prefetch', 'https://fonts.gstatic.com');
      }
      injectLink('preconnect', 'https://js.stripe.com');
      injectLink('dns-prefetch', 'https://js.stripe.com');
      // Ensure perf stylesheet is loaded early
      try {
        if (!document.head.querySelector('link[href*="perf.css"]')) {
          const perf = document.createElement('link');
          perf.rel = 'stylesheet';
          // Avoid duplicating '/static' if STATIC_URL already includes it
          var base = window.STATIC_URL || '';
          if (base.endsWith('/static')) {
            perf.href = base + '/css/perf.css';
          } else {
            perf.href = base + '/static/css/perf.css';
          }
          document.head.appendChild(perf);
        }
      } catch { /* Error ignored */ }

      // Low-risk fix: ensure Stripe script is async/defer if present in DOM
      try {
        const stripeScript = document.querySelector(
          'script[src^="https://js.stripe.com/v3/"]'
        );
        if (stripeScript) {
          stripeScript.async = true;
          stripeScript.defer = true;
        }
      } catch { /* Error ignored */ }
    } catch { /* Error ignored */ }

    // Collect recent errors for diagnostics
    window.__jsErrors = window.__jsErrors || [];

    function recordError(kind, error, extra) {
      try {
        const entry = {
          kind,
          message:
            (error && (error.message || error.toString())) || String(error),
          stack: error && error.stack ? String(error.stack) : null,
          extra: extra || null,
          when: Date.now(),
        };
        window.__jsErrors.push(entry);
        if (window.__jsErrors.length > 50) {
          window.__jsErrors.shift();
        }
      } catch { /* Error ignored */ }
    }

    // Global error handlers (non-fatal, do not rethrow)
    window.addEventListener('error', function (event) {
      try {
        // Avoid infinite loops by ignoring errors originating from this handler
        recordError('error', event.error || event.message || 'Unknown', {
          source: event.filename,
          lineno: event.lineno,
          colno: event.colno,
        });
        // Keep the app running
      } catch { /* Error ignored */ }
    });

    window.addEventListener('unhandledrejection', function (event) {
      try {
        recordError('unhandledrejection', event.reason || 'Unknown');
      } catch { /* Error ignored */ }
    });

    // Wrap async scheduling and event listeners to prevent cascading failures
    try {
      // setTimeout / setInterval wrappers
      const originalSetTimeout = window.setTimeout;
      const originalSetInterval = window.setInterval;
      window.setTimeout = function (handler, timeout, ...args) {
        const safeHandler = function () {
          try {
            return (
              typeof handler === 'function'
                ? handler
                : new Function(String(handler))
            )(...args);
          } catch (e) {
            console.error('setTimeout handler error:', e);
            recordError('timeout', e);
          }
        };
        return originalSetTimeout(safeHandler, timeout);
      };
      window.setInterval = function (handler, timeout, ...args) {
        const safeHandler = function () {
          try {
            return (
              typeof handler === 'function'
                ? handler
                : new Function(String(handler))
            )(...args);
          } catch (e) {
            console.error('setInterval handler error:', e);
            recordError('interval', e);
          }
        };
        return originalSetInterval(safeHandler, timeout);
      };

      // Event listener wrapper with WeakMap for removals
      const addMap = new WeakMap();
      const originalAdd = EventTarget.prototype.addEventListener;
      const originalRemove = EventTarget.prototype.removeEventListener;
      const defaultPassiveEvents = new Set([
        'touchstart',
        'touchmove',
        'wheel',
        'mousewheel',
        'scroll',
      ]);
      EventTarget.prototype.addEventListener = function (
        type,
        listener,
        options
      ) {
        if (typeof listener !== 'function')
          return originalAdd.call(this, type, listener, options);
        let wrapped = addMap.get(listener);
        if (!wrapped) {
          wrapped = function (event) {
            try {
              return listener.call(this, event);
            } catch (e) {
              console.error('Event handler error for', type, e);
              recordError('event', e, { type });
            }
          };
          addMap.set(listener, wrapped);
        }
        // Default passive listeners for scroll/touch if not explicitly specified
        let finalOptions = options;
        if (defaultPassiveEvents.has(type)) {
          if (options == null) {
            finalOptions = { passive: true };
          } else if (typeof options === 'object' && !('passive' in options)) {
            finalOptions = { ...options, passive: true };
          }
        }
        const result = originalAdd.call(this, type, wrapped, finalOptions);
        // If a window 'load' listener is registered after load has already fired, run it once immediately
        try {
          if (
            this === window &&
            type === 'load' &&
            document.readyState === 'complete'
          ) {
            setTimeout(() => {
              try {
                wrapped.call(window, new Event('load'));
              } catch { /* Error ignored */ }
            }, 0);
          }
        } catch { /* Error ignored */ }
        return result;
      };
      EventTarget.prototype.removeEventListener = function (
        type,
        listener,
        options
      ) {
        const wrapped = addMap.get(listener) || listener;
        return originalRemove.call(this, type, wrapped, options);
      };
    } catch (_) {
      /* ignore if environment forbids */
    }

    // Safe dynamic import that never throws
    async function safeImport(path) {
      try {
        return await import(/* @vite-ignore */ path);
      } catch (e) {
        console.error('Module failed to load:', path, e);
        recordError('module-import', e, { path });
        return null;
      }
    }

    async function loadModulesSafely(paths) {
      const results = [];
      for (const p of paths) {
        // Small yield to avoid blocking

        results.push(await safeImport(p));
      }
      return results;
    }

    window.safeImport = window.safeImport || safeImport;
    window.loadModulesSafely = window.loadModulesSafely || loadModulesSafely;

    // Defensive shims for frequently-missed globals to avoid hard crashes
    try {
      // Template utils fallback so bare calls don't break the app
      if (!window.TemplateUtils) window.TemplateUtils = {};
      if (typeof window.TemplateUtils.getTagsTemplate !== 'function') {
        window.TemplateUtils.getTagsTemplate = function (tags) {
          if (!tags || !Array.isArray(tags)) return '';
          try {
            var out = '<div class="mdl-card__supporting-text">';
            for (var i = 0; i < tags.length; i++) {
              var t = ('' + tags[i]).trim();
              if (!t) continue;
              var d = t.length > 20 ? t.substring(0, 20) + '...' : t;
              var enc = encodeURIComponent(t);
              out +=
                '<div class="mdl-chip"><span class="mdl-chip__text"><a href="/ai-chatbots?category=' +
                enc +
                '" target="_blank" data-bypass>' +
                d +
                '</a></span></div>';
            }
            return out + '</div>';
          } catch (_) {
            return '';
          }
        };
      }
      if (typeof window.getTagsTemplate !== 'function') {
        window.getTagsTemplate = window.TemplateUtils.getTagsTemplate;
      }
      // Provide a global setCookie fallback very early
      if (typeof window.setCookie !== 'function') {
        window.setCookie = function (name, value, days) {
          try {
            if (
              window.CookieUtils &&
              typeof window.CookieUtils.setCookie === 'function'
            ) {
              return window.CookieUtils.setCookie(name, value, days);
            }
            var expires = '';
            if (days) {
              var d = new Date();
              d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
              expires = '; expires=' + d.toGMTString();
            }
            document.cookie =
              name + '=' + value + expires + '; path=/; SameSite=Strict';
          } catch { /* Error ignored */ }
        };
      }

      // Auth modal fallbacks so inline onclick handlers don't break
      if (typeof window.showLoginDialog !== 'function') {
        window.showLoginDialog = function (event, nextUrl) {
          try {
            if (event && typeof event.preventDefault === 'function')
              event.preventDefault();
            if (event && typeof event.stopPropagation === 'function')
              event.stopPropagation();
            var dialog = document.getElementById('login-dialog');
            if (dialog) {
              dialog.removeAttribute('inert');
              dialog.style.display = 'block';
              dialog.style.visibility = 'visible';
              dialog.style.opacity = '1';
              // Optionally record next URL
              if (
                nextUrl &&
                dialog.querySelector &&
                dialog.querySelector('#login-next')
              ) {
                var nextInput = dialog.querySelector('#login-next');
                if (nextInput) nextInput.value = String(nextUrl);
              }
              if (typeof dialog.showModal === 'function') {
                try {
                  dialog.showModal();
                } catch (_) {
                  dialog.open = true;
                }
              } else {
                dialog.open = true;
              }
              dialog.setAttribute('open', '');
              return false;
            }
          } catch { /* Error ignored */ }
          return false;
        };
      }
      if (typeof window.showSignupDialog !== 'function') {
        window.showSignupDialog = function (event, nextUrl) {
          try {
            if (event && typeof event.preventDefault === 'function')
              event.preventDefault();
            if (event && typeof event.stopPropagation === 'function')
              event.stopPropagation();
            var dialog = document.getElementById('signup-dialog');
            if (dialog) {
              dialog.removeAttribute('inert');
              dialog.style.display = 'block';
              dialog.style.visibility = 'visible';
              dialog.style.opacity = '1';
              if (nextUrl && dialog.querySelector) {
                var nextInput2 = dialog.querySelector('#signup-next');
                if (nextInput2) nextInput2.value = String(nextUrl);
              }
              if (typeof dialog.showModal === 'function') {
                try {
                  dialog.showModal();
                } catch (_) {
                  dialog.open = true;
                }
              } else {
                dialog.open = true;
              }
              dialog.setAttribute('open', '');
              return false;
            }
          } catch { /* Error ignored */ }
          return false;
        };
      }
    } catch { /* Error ignored */ }

    // Page-ready helper
    if (!window.onPageReady) {
      window.onPageReady = function (run) {
        if (typeof run !== 'function') return;
        if (
          document.readyState === 'interactive' ||
          document.readyState === 'complete'
        ) {
          try {
            run();
          } catch (e) {
            console.error(e);
            try {
              (window.__recordError || function () {})('ready', e);
            } catch { /* Error ignored */ }
          }
        } else {
          document.addEventListener('DOMContentLoaded', function () {
            try {
              run();
            } catch (e) {
              console.error(e);
              try {
                (window.__recordError || function () {})('ready', e);
              } catch { /* Error ignored */ }
            }
          });
        }
      };
    }

    // Lightweight Web Vitals observers (console + window.__webVitals)
    try {
      const vitals = (window.__webVitals = window.__webVitals || {
        cls: 0,
        lcp: 0,
        fid: 0,
        inp: 0,
        longTasks: 0,
      });
      if ('PerformanceObserver' in window) {
        // CLS
        const clsObserver = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (!entry.hadRecentInput) {
              vitals.cls += entry.value || entry.score || 0;
            }
          }
        });
        try {
          clsObserver.observe({ type: 'layout-shift', buffered: true });
        } catch { /* Error ignored */ }

        // LCP
        let lcpValue = 0;
        const lcpObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const last = entries[entries.length - 1];
          if (last) {
            lcpValue =
              last.renderTime || last.loadTime || last.startTime || lcpValue;
            vitals.lcp = lcpValue;
          }
        });
        try {
          lcpObserver.observe({
            type: 'largest-contentful-paint',
            buffered: true,
          });
        } catch { /* Error ignored */ }
        ['visibilitychange', 'pagehide'].forEach((evt) => {
          addEventListener(
            evt,
            () => {
              try {
                lcpObserver.disconnect();
              } catch { /* Error ignored */ }
            },
            { once: true }
          );
        });

        // FID (first input delay)
        const fidObserver = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            const delay = entry.processingStart - entry.startTime;
            if (delay > 0) {
              vitals.fid = delay;
            }
          }
        });
        try {
          fidObserver.observe({ type: 'first-input', buffered: true });
        } catch { /* Error ignored */ }

        // INP (approx via Event timing, if available)
        try {
          const inpObserver = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
              // duration approximates interaction latency
              if (entry.duration && entry.duration > vitals.inp)
                vitals.inp = entry.duration;
            }
          });
          inpObserver.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16,
          });
        } catch { /* Error ignored */ }

        // Long tasks (Total Blocking Time proxy)
        try {
          const ltObserver = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
              const blocking = Math.max(0, (entry.duration || 0) - 50);
              vitals.longTasks += blocking;
            }
          });
          ltObserver.observe({ type: 'longtask', buffered: true });
        } catch { /* Error ignored */ }
      }
      // Log once after load
      addEventListener(
        'load',
        () => {
          setTimeout(() => {
            try {
            } catch { /* Error ignored */ }
          }, 0);
        },
        { once: true }
      );
    } catch { /* Error ignored */ }

    // Ensure highlight.js runs once when available
    try {
      (function ensureHL() {
        let ran = false;
        function tryRun() {
          if (ran) return;
          if (window.hljs && typeof window.hljs.highlightAll === 'function') {
            ran = true;
            try {
              window.hljs.highlightAll();
            } catch { /* Error ignored */ }
            return true;
          }
          return false;
        }
        if (!tryRun()) {
          const start = Date.now();
          const timer = setInterval(() => {
            if (tryRun() || Date.now() - start > 5000) clearInterval(timer);
          }, 250);
          document.addEventListener('readystatechange', () => {
            if (document.readyState === 'complete') tryRun();
          });
        }
      })();
    } catch { /* Error ignored */ }

    // Hint browser to prioritize likely LCP image
    try {
      const prioritizeHero = () => {
        const hero = document.querySelector(
          'img.chat-one-to-one-icon, .mdl-card__title img'
        );
        if (hero) {
          hero.setAttribute('fetchpriority', 'high');
          hero.setAttribute('decoding', 'async');
          if (!hero.hasAttribute('loading'))
            hero.setAttribute('loading', 'eager');
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', prioritizeHero, {
          once: true,
        });
      } else {
        prioritizeHero();
      }
    } catch { /* Error ignored */ }
  }
})();
